var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('p',[_c('span',[_vm._v("©")]),_c('span',[_vm._v(_vm._s(new Date().getFullYear())+" ")]),_c('a',{attrs:{"href":_vm.url,"target":"_blank","rel":"nofollow"}},[_vm._v("Coach")]),_c('span',{staticClass:"sm:inline-block"},[_vm._v(", All rights Reserved")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }